import dom from "../../../../common/ts/core/dom";
import {EventBus} from "../../../../common/ts/events/EventBus";
import {WlTree} from "../../../../common/ts/webcomponents/tree/tree.component";
import {MitulaSerpPageData} from "../SerpPage";
import {FILTER_NAMES} from "./constants";

dom.init();
const eventBus: EventBus = EventBus.getInstance()

function init(pageData: MitulaSerpPageData) {

    eventBus.emit(new dom.AddClickListenerEvent({
        selector: '.js-geo-children-clear-selection',
        listener: () => {
            (dom.select('.js_filter-geo-children') as WlTree).clear();
        }
    }))
}

export default {
    init,
}